import { Beer } from '../../state/types'

export interface BeerListPartition {
  beersInList: Beer[]
  beersNotInList: Beer[]
  shouldAdd: boolean
  displayCount: number
}

export interface BeerFavouritePartition {
  beersFavourited: Beer[]
  beersNotFavourited: Beer[]
  shouldFavourite: boolean
  displayCount: number
}

export function partitionBeersByTastingList(
  selectedBeers: Beer[],
  tastingList: string[],
  showForOnboarding: boolean
): BeerListPartition {
  const beersInList = selectedBeers.filter(beer => tastingList.includes(beer.id))
  const beersNotInList = selectedBeers.filter(beer => !tastingList.includes(beer.id))
  const shouldAdd = beersNotInList.length >= beersInList.length

  const demoCount = 1
  const displayCount = selectedBeers.length === 0 && showForOnboarding
    ? demoCount
    : (shouldAdd ? beersNotInList.length : beersInList.length)

  return { beersInList, beersNotInList, shouldAdd, displayCount }
}

export function partitionBeersByFavourites(
  selectedBeers: Beer[],
  favorites: string[],
  showForOnboarding: boolean
): BeerFavouritePartition {
  const beersFavourited = selectedBeers.filter(beer => favorites.includes(beer.id))
  const beersNotFavourited = selectedBeers.filter(beer => !favorites.includes(beer.id))
  const shouldFavourite = beersNotFavourited.length >= beersFavourited.length

  const demoCount = 1
  const displayCount = selectedBeers.length === 0 && showForOnboarding
    ? demoCount
    : (shouldFavourite ? beersNotFavourited.length : beersFavourited.length)

  return { beersFavourited, beersNotFavourited, shouldFavourite, displayCount }
}

export function applyVisualFeedbackToCards(beers: Beer[], shouldAdd: boolean): void {
  beers.forEach(beer => {
    const card = document.getElementById(`beer-card-${beer.id}`)
    if (!card) return

    const leftColumn = card.querySelector('[data-left-column]') as HTMLElement
    if (leftColumn) {
      leftColumn.style.backgroundColor = shouldAdd
        ? 'color-mix(in srgb, var(--primary-colour) 90%, transparent)'
        : 'transparent'
    }

    const numberEl = card.querySelector('[data-number]') as HTMLElement
    if (numberEl) {
      numberEl.style.color = shouldAdd ? 'rgba(255, 255, 255, 1)' : 'var(--primary-colour)'
    }
  })
}

export function buildActionMessage(count: number, shouldAdd: boolean, actionType: 'list' | 'favourite'): string {
  const plural = count > 1 ? 's' : ''
  
  if (actionType === 'list') {
    return shouldAdd
      ? `Added ${count} beer${plural} to List!`
      : `Removed ${count} beer${plural} from List`
  }
  
  return shouldAdd
    ? `Added ${count} beer${plural} to Favourites!`
    : `Removed ${count} beer${plural} from Favourites`
}
